const ADMIN = "admin"
const PROVINCE_OFFICIAL = 1
const DISTRICT_OFFICIAL = 2
const WARD_OFFICIAL = 3
const PROCESS_OFFICIAL = 4
const USER = 99
export {ADMIN, PROVINCE_OFFICIAL, DISTRICT_OFFICIAL, WARD_OFFICIAL, PROCESS_OFFICIAL, USER}